<template>
  <span @click.prevent="$emit('click', image)">
    <v-lazy-image :src="imageURL" src-placeholder="/img/placeholder.png" />
  </span>
</template>

<script>
import VLazyImage from "v-lazy-image/v2/v-lazy-image.es";
export default {
  components: {
    VLazyImage,
  },
  props: {
    image: String,
  },
  computed: {
    imageURL() {
      return `${this.$myServerAddresses.images}img/${this.image}`;
    },
  },
};
</script>
